<template lang="pug">
    #z-deal-freight.tab-content.deal-freight-card
        .md-layout.md-gutter(v-loader-overlay="progressMainFreight")
            .md-layout-item.md-alignment-top-left.md-size-100
                z-input(
                    label="Наименование груза"
                    v-model="freight.description"
                    :required="true"
                    name="freight_description"
                    id="freight_description"
                    v-validate="'required|min:1|max:100'"
                    v-bind:error="errors.first('freight_description')"
                    data-vv-name="freight_description"
                    v-bind:data-vv-as="' '"
                    v-bind:disabled="blocked"
                    v-bind:dirty.sync="dirtyObj.description"
                )
            .md-layout-item.md-alignment-top-left.md-size-100
                .md-subheading Основные характеристики

            .md-layout-item.md-alignment-top-left.md-size-50.deal-freight-card__freight-params
                z-input(
                    v-bind:label="('Вес (кг)' + (OversizeType.find(item => item == 'weight') ? ', <span style=color: red;>Негабарит</span>' : ''))"
                    v-model="freight.weight"
                    :required="true"
                    :select-on-focus="true"
                    name="freight_weight"
                    id="freight_weight"
                    v-validate="{required: true, min_value: 0.001, max_value: 25000, decimal: [3, '.']}"
                    v-bind:error="errors.first('freight_weight')"
                    data-vv-name="freight_weight"
                    v-bind:data-vv-as="' '"
                    type="number"
                    v-bind:disabled="blocked"
                    inline

                    v-bind:dirty.sync="dirtyObj.weight"
                )
                z-input(
                    v-bind:label="'Объём (м^3)' + (OversizeType.find(item => (item == 'size' || item == 'volume')) ? ', <span style=color: red;>Негабарит</span>' : '')"
                    v-model="freight.size"
                    :required="true"
                    :select-on-focus="true"
                    name="freight_size"
                    id="freight_size"
                    v-validate="{required: true, min_value: 0.001, max_value: 9999999999, decimal: [3, '.']}"
                    v-bind:error="errors.first('freight_size')"
                    data-vv-name="freight_size"
                    v-bind:data-vv-as="' '"
                    type="number"
                    v-bind:disabled="(blocked || (!!computedVolume && computedVolume > 0))"
                    inline
                    v-bind:dirty.sync="dirtyObj.size"
                )
                z-input(
                    label="Количество мест"
                    v-model="freight.seats_number"
                    :required="true"
                    :select-on-focus="true"
                    name="freight_seats_number"
                    id="freight_seats_number"
                    v-validate="{required: true, min_value: 0.001, max_value: 9999999999, decimal: [3, '.']}"
                    v-bind:error="errors.first('freight_seats_number')"
                    data-vv-name="freight_seats_number"
                    v-bind:data-vv-as="' '"
                    type="number"
                    v-bind:disabled="blocked"
                    inline
                    v-bind:dirty.sync="dirtyObj.seats"
                )                

            .md-layout-item.md-alignment-top-left.md-size-50.deal-freight-card__freight-params
                z-input(
                    v-bind:label="'Высота (м)' + (OversizeType.find(item => item == 'height') ? ', <span style=color: red;>Негабарит</span>' : '')"
                    v-model="freight.height"
                    :select-on-focus="true"
                    name="freight_height"
                    id="freight_height"
                    v-validate="{required: (!freight.size || freight.size < 0), min_value: (freight.size ? 0 : 0.001), max_value: 9999999999, decimal: [3, '.']}"
                    v-bind:error="errors.first('freight_height')"
                    data-vv-name="freight_height"
                    v-bind:data-vv-as="' '"
                    type="number"
                    v-bind:disabled="blocked"
                    inline
                    v-bind:dirty.sync="dirtyObj.height"
                )
                z-input(
                    v-bind:label="'Длина (м)' + (OversizeType.find(item => item == 'length') ? ', <span style=color: red;>Негабарит</span>' : '')"
                    v-model="freight.length"
                    :select-on-focus="true"
                    name="freight_length"
                    id="freight_length"
                    v-validate="{required: (!freight.size || freight.size < 0), min_value: (freight.size ? 0 : 0.001), max_value: 9999999999, decimal: [3, '.']}"
                    v-bind:error="errors.first('freight_length')"
                    data-vv-name="freight_length"
                    v-bind:data-vv-as="' '"
                    type="number"
                    v-bind:disabled="blocked"
                    inline
                    v-bind:dirty.sync="dirtyObj.length"
                )
                z-input(
                    v-bind:label="'Ширина (м)' + (OversizeType.find(item => item == 'width') ? ', <span style=color: red;>Негабарит</span>' : '')"
                    v-model="freight.width"
                    :select-on-focus="true"
                    name="freight_width"
                    id="freight_width"
                    v-validate="{required: (!freight.size || freight.size < 0), min_value: (freight.size ? 0 : 0.001), max_value: 9999999999, decimal: [3, '.']}"
                    v-bind:error="errors.first('freight_width')"
                    data-vv-name="freight_width"
                    v-bind:data-vv-as="' '"
                    type="number"
                    v-bind:disabled="blocked"
                    inline
                    v-bind:dirty.sync="dirtyObj.width"
                )
            
            .md-layout-item.md-alignment-top-left.md-size-100
                z-check(
                    v-show="freight.weight > 0 && freight.size > 0"
                    :label="`Негабаритный груз ${ fullOversizeMessage ? '(' + fullOversizeMessage +  ')' : '' }`"
                    id="freight_oversize"
                    v-model="freight.oversize"
                    v-bind:value="1"
                    v-bind:error="errors.first('freight_oversize')"
                    data-vv-name="freight_oversize"
                    v-bind:data-vv-as="' '"
                    v-bind:disabled="blocked || (!!parseInt(freight.full_oversize) && !!parseInt(freight.doom))"
                    v-bind:dirty.sync="dirtyObj.oversize"
                )

            .md-layout-item.md-alignment-top-left.md-size-50.deal-freight-card__freight-params(v-show="parseInt(freight.oversize) === 1")
                z-input(
                    label="Вес негабарита"
                    v-model="freight.oversize_weight"
                    :required="true"
                    :select-on-focus="true"
                    name="freight_oversize_weight"
                    id="freight_oversize_weight"
                    type="number"
                    v-validate="{required: (parseInt(freight.oversize) === 1), min_value: 0, max_value: ((!!parseInt(freight.full_oversize)) ? 25000 : (freight.weight ? parseFloat(freight.weight) : 0)), decimal: [3, '.']}"
                    v-bind:error="errors.first('freight_oversize_weight')"
                    data-vv-name="freight_oversize_weight"
                    v-bind:data-vv-as="' '"
                    v-bind:disabled="blocked || (!!parseInt(freight.full_oversize) && !!parseInt(freight.doom))"
                    inline
                    v-bind:dirty.sync="dirtyObj.oversizeWeight"
                )
                z-input(
                    label="Объём негабарита"
                    v-model="freight.oversize_size"
                    :required="true"
                    :select-on-focus="true"
                    name="freight_oversize_size"
                    id="freight_oversize_size"
                    type="number"
                    v-validate="{required: (parseInt(freight.oversize) === 1), min_value: 0, max_value:  ((!!parseInt(freight.full_oversize)) ? 9999999999 : (freight.size ? parseFloat(freight.size) : 0)), decimal: [3, '.']}"
                    v-bind:error="errors.first('freight_oversize_size')"
                    data-vv-name="freight_oversize_size"
                    v-bind:data-vv-as="' '"
                    v-bind:disabled="(blocked || (!!parseInt(freight.full_oversize) && !!parseInt(freight.doom)))"
                    inline
                    v-bind:dirty.sync="dirtyObj.oversizeSize"
                )

            .md-layout-item.md-alignment-top-left.md-size-50.deal-freight-card__freight-params(v-show="parseInt(freight.oversize) === 1 && !hasDoom && computedSum > 0")
                z-input(
                    v-show="(!hasDoom && parseInt(freight.oversize) && freight.height > 0 ? true : false)"
                    label="Высота негабарита (м)"
                    v-model="freight.oversize_height"
                    :select-on-focus="true"
                    name="freight_oversize_height"
                    id="freight_oversize_height"
                    v-validate="{required: false, min_value: 0, max_value: ((!!parseInt(freight.full_oversize)) ? 9999999999 : (freight.height ? parseFloat(freight.height) : 0)), decimal: [3, '.']}"
                    v-bind:error="errors.first('freight_oversize_height')"
                    data-vv-name="freight_oversize_height"
                    v-bind:data-vv-as="' '"
                    type="number"
                    v-bind:disabled="true"
                    inline
                    v-bind:dirty.sync="dirtyObj.oversizeHeight"
                )
                z-input(
                    v-show="(!hasDoom && parseInt(freight.oversize) && freight.length > 0 ? true : false)"
                    label="Длина негабарита (м)"
                    v-model="freight.oversize_length"
                    :select-on-focus="true"
                    name="freight_oversize_length"
                    id="freight_oversize_length"
                    v-validate="{required: false, min_value: 0, max_value: ((!!parseInt(freight.full_oversize)) ? 9999999999 : (freight.length ? parseFloat(freight.length) : 0)), decimal: [3, '.']}"
                    v-bind:error="errors.first('freight_oversize_length')"
                    data-vv-name="freight_oversize_length"
                    v-bind:data-vv-as="' '"
                    type="number"
                    v-bind:disabled="true"
                    inline
                    v-bind:dirty.sync="dirtyObj.oversizeLength"
                )
                z-input(
                    v-show="(!hasDoom && parseInt(freight.oversize) && freight.width > 0 ? true : false)"
                    label="Ширина негабарита (м)"
                    v-model="freight.oversize_width"
                    :select-on-focus="true"
                    name="freight_oversize_width"
                    id="freight_oversize_width"
                    v-validate="{required: false, min_value: 0, max_value: ((!!parseInt(freight.full_oversize)) ? 9999999999 : (freight.width ? parseFloat(freight.width) : 0)), decimal: [3, '.']}"
                    v-bind:error="errors.first('freight_oversize_width')"
                    data-vv-name="freight_oversize_width"
                    v-bind:data-vv-as="' '"
                    type="number"
                    v-bind:disabled="true"
                    inline
                    v-bind:dirty.sync="dirtyObj.oversizeWidth"
                )

                z-input(
                    v-show="(!hasDoom && parseInt(freight.oversize) && computedSum > 0 ? true : false)"
                    v-bind:label="'Сумма (м)' + (OversizeType.find(item => item == 'sum') ? ', <span style=color: red;>Негабарит</span>' : '')"
                    v-bind:value="computedSum"
                    :required="true"
                    :select-on-focus="true"
                    name="freight_oversize_sum"
                    id="freight_oversize_sum"
                    type="number"
                    data-vv-name="freight_oversize_sum"
                    v-bind:data-vv-as="' '"
                    v-bind:disabled="true"
                    inline
                    v-bind:dirty.sync="dirtyObj.sum"
                )

            .md-layout-item.md-alignment-top-left.md-size-100

            .md-layout-item.md-alignment-top-left.md-size-100
                .md-subheading Услуги
                z-check(
                    label="Оформление ТТН"
                    id="freight_ttn"
                    v-model="ttn"
                    v-bind:value="true"
                    v-bind:error="errors.first('freight_ttn')"
                    data-vv-name="freight_ttn"
                    v-bind:data-vv-as="' '"
                    v-bind:disabled="true"
                )

                z-check(
                    label="Представление интересов в аэропорту"
                    id="freight_airport_service"
                    v-model="freight.airport_service"
                    v-bind:value="1"
                    v-bind:error="errors.first('freight_airport_service')"
                    data-vv-name="freight_airport_service"
                    v-bind:data-vv-as="' '"
                    v-bind:disabled="blocked"
                    v-bind:dirty.sync="dirtyObj.airportService"
                )

                z-check(
                    v-show="freight.weight > 0 && freight.size > 0"
                    v-bind:label="doomLabel"
                    id="freight_doom"
                    v-model="freight.doom"
                    v-bind:value="1"
                    v-bind:error="errors.first('freight_doom')"
                    data-vv-name="freight_doom"
                    v-bind:data-vv-as="' '"
                    v-bind:disabled="blocked"
                    v-bind:dirty.sync="dirtyObj.doom"
                )
                // Логику изготовления обрешётки выносим отдельно чтобы иметь возможность блокировать её по флагу freight.doom
                div(v-if="freight.extraservices && freight.extraservices.doom_make")
                    ZFreightExtraService(
                        v-model="freight.extraservices.doom_make.value"
                        v-bind:disabledCheck="true"
                        v-bind:payers="$props.payers"
                        v-bind:name="('extraserivce-doom_make')"
                        v-bind:label="freight.extraservices.doom_make.name"
                        v-bind:disabled="blocked || !freight.doom"
                        v-bind:ref="('extraserivce-doom_make')"
                    )

                // Старая логика обрешётки
                //z-check(
                    v-show="freight.weight > 0 && freight.size > 0"
                    label="Изготовление обрешётки"
                    id="freight_doom_make"
                    v-model="freight.doom_make"
                    v-bind:value="1"
                    v-bind:error="errors.first('freight_doom_make')"
                    data-vv-name="freight_doom_make"
                    v-bind:data-vv-as="' '"
                    v-bind:disabled="$props.block"
                    v-bind:dirty.sync="dirtyObj.doom_make"
                    )

                div(v-if="freight.extraservices && Object.values(freight.extraservices).length" v-for="(service, key) in extraservicesDefault")
                    ZFreightExtraService(
                        v-if="!['doom_make', 'storage'].indexOf(key)+1"
                        v-model="freight.extraservices[key]['value']"
                        v-bind:payers="$props.payers"
                        v-bind:name="('extraserivce-' + key)"
                        v-bind:label="service.label"
                        v-bind:disabled="blocked"
                        v-bind:ref="('extraserivce-' + key)"
                    )

            .md-layout-item.md-alignment-top-left.md-size-100
                div(v-if="freight.extraservices && freight.extraservices.storage")
                    ZFreightExtraService(
                        v-model="freight.extraservices.storage.value"
                        v-bind:payers="$props.payers"
                        v-bind:name="('extraserivce-storage')"
                        v-bind:label="freight.extraservices.storage.name"
                        v-bind:disabledCheck="true"
                        v-bind:disabled="blocked"
                        v-bind:ref="('extraserivce-storage')"
                    )

            .md-layout-item.md-alignment-top-left.md-size-50(v-show="shwowLuwFrom || shwowLuwTo")
                .md-subheading Погрузочно-разгрузочные работы
                .md-layout.md-gutter
                    .md-layout-item.md-alignment-top-left.md-size-50
                        span.md-caption(v-show="shwowLuwFrom" v-html="`Отправление ${fromLuw.min_time ? ' <b>(мин. ' + fromLuw.min_time + 'ч)</b>' : ''}`")
                        z-input(
                            v-show="shwowLuwFrom"
                            label="Сотрудники"
                            v-model="freight.from_luw_workers"
                            name="freight_from_luw_workers"
                            id="freight_from_luw_workers"
                            v-validate="{ required: false, min_value: 0, max_value: 99999 }"
                            v-bind:error="errors.first('freight_from_luw_workers')"
                            data-vv-name="freight_from_luw_workers"
                            v-bind:data-vv-as="' '"
                            type="number"
                            inline
                            v-bind:disabled="blocked"
                            v-bind:dirty.sync="dirtyObj.fromLuwWorkers"
                        )
                        z-input(
                            v-show="shwowLuwFrom"
                            label="Часы"
                            v-model="freight.from_luw_hours"
                            name="freight_from_luw_hours"
                            id="freight_from_luw_hours"
                            v-validate="{ required: false, min_value: 0, max_value: 99999 }"
                            v-bind:error="errors.first('freight_from_luw_hours')"
                            data-vv-name="freight_from_luw_hours"
                            v-bind:data-vv-as="' '"
                            type="number"
                            inline
                            v-bind:disabled="blocked"
                            v-bind:dirty.sync="dirtyObj.fromLuwHours"
                        )

                    .md-layout-item.md-alignment-top-left.md-size-50
                        span.md-caption(v-show="shwowLuwTo" v-html="`Назначение ${toLuw.min_time ? ' <b>(мин. ' + toLuw.min_time + 'ч)</b>' : ''}`")
                        // Представитель может редактировать ПРР в п. назначения только если услуга не была добавлена ранее (даже им самим)
                        z-input(
                            v-show="shwowLuwTo"
                            label="Сотрудники"
                            v-model="freight.to_luw_workers"
                            name="freight_to_luw_workers"
                            id="freight_to_luw_workers"
                            v-validate="{ required: false, min_value: 0, max_value: 99999 }"
                            v-bind:error="errors.first('freight_to_luw_workers')"
                            data-vv-name="freight_to_luw_workers"
                            v-bind:data-vv-as="' '"
                            type="number"
                            inline
                            v-bind:disabled="blocked && freight.to_luw_workers > 0 && !dirtyObj.toLuwWorkers"
                            v-bind:dirty.sync="dirtyObj.toLuwWorkers"
                        )

                        z-input(
                            v-show="shwowLuwTo"
                            label="Часы"
                            v-model="freight.to_luw_hours"
                            name="freight_to_luw_hours"
                            id="freight_to_luw_hours"
                            v-validate="{ required: false, min_value: 0, max_value: 99999 }"
                            v-bind:error="errors.first('freight_to_luw_hours')"
                            data-vv-name="freight_to_luw_hours"
                            v-bind:data-vv-as="' '"
                            type="number"
                            inline
                            v-bind:disabled="blocked && freight.to_luw_hours > 0 && !dirtyObj.toLuwHours"
                            v-bind:dirty.sync="dirtyObj.toLuwHours"
                        )

            .md-layout-item.md-alignment-top-left.md-size-50(v-show="shwowManipulatorFrom || shwowManipulatorTo")
                .md-subheading Услуги манипулятора
                .md-layout.md-gutter
                    .md-layout-item.md-alignment-top-left.md-size-100
                        z-input(
                            v-show="shwowManipulatorFrom"
                            :label="`Отправление ${manupulatorPrice.min_time ? ' <br/><b>(мин. ' + manupulatorPrice.min_time + 'ч, ' + manupulatorPrice.price + 'руб./ч)</b>' : '(часы)'}`"
                            v-model="freight.from_manipulator_hours"
                            name="freight_from_manipulator_hours"
                            id="freight_from_manipulator_hours"
                            v-validate="{ required: false, min_value: 0, max_value: 99999 }"
                            v-bind:error="errors.first('freight_from_manipulator_hours')"
                            data-vv-name="freight_from_manipulator_hours"
                            v-bind:data-vv-as="' '"
                            type="number"
                            inline
                            v-bind:disabled="blocked"
                            v-bind:dirty.sync="dirtyObj.fromManipulatorHours"
                        )

                        z-input(
                            v-show="shwowManipulatorTo"
                            :label="`Назначение ${manupulatorPrice.min_time ? ' <b>(мин. ' + manupulatorPrice.min_time + 'ч)</b>' : '(часы)'}`"
                            v-model="freight.to_manipulator_hours"
                            name="freight_to_manipulator_hours"
                            id="freight_to_manipulator_hours"
                            v-validate="{ required: false, min_value: 0, max_value: 99999 }"
                            v-bind:error="errors.first('freight_to_manipulator_hours')"
                            data-vv-name="freight_to_manipulator_hours"
                            v-bind:data-vv-as="' '"
                            type="number"
                            inline
                            v-bind:disabled="blocked"
                            v-bind:dirty.sync="dirtyObj.toManipulatorHours"
                        )

        .md-layout.md-gutter
            .md-layout-item.md-size-50(v-for="(serviceSection, i) in servicesSections" v-bind:key="('freight-services-section-' + i)")
                .md-subheading {{ serviceSection.title }}
                .md-layout.md-gutter(v-if="services && services[ serviceSection.key ]")
                    .md-layout-item.md-alignment-top-left.md-size-100(v-for="(item, s) in services[ serviceSection.key ]" v-bind:key="('service-' + item.id)")
                        div(v-if="(['checkbox', 'grid-city', 'grid-dimensions', 'grid-paymethod', 'grid-city-dimensions'].indexOf(item.type)+1) && item.values && item.values.length === 1")
                            z-check(
                                v-for="(check, n) in item.values"
                                v-bind:key="('service-item-check-' + check.id)"
                                v-bind:label="check.name"
                                v-bind:name="('freight_service_' + item.id)"
                                v-bind:id="('freight_service_' + item.id + '-' + check.id)"
                                v-model="item.value"
                                v-bind:value="check.id"
                                v-bind:error="errors.first(('freight_service_' + item.id + '-' + check.id))"
                                v-bind:data-vv-name="('freight_service_' + item.id + '-' + check.id)"
                                v-bind:data-vv-as="' '"
                                v-bind:disabled="blocked"
                                v-bind:dirty.sync="dirtyObj[('service-' + item.id + '-' + check.id)]"
                                v-on:change="changeService"
                            )

                        .z-check-container(v-if="item.type == 'checkbox' && item.values && item.values.length > 1")
                            .md-caption {{item.name}}
                            .md-layout.md-gutter
                                .md-layout-item.md-size-100(v-for="(check, n) in item.values" v-bind:key="('service-item-mcheck-' + check.id)")
                                    z-check(
                                        v-bind:label="check.name"
                                        v-bind:name="('freight_service_' + item.id)"
                                        v-bind:id="('freight_service_' + item.id + '-' + check.id)"
                                        v-model="item.value"
                                        v-bind:value="parseInt(check.id)"
                                        v-bind:error="errors.first(('freight_service_' + item.id + '-' + check.id))"
                                        v-bind:data-vv-name="('freight_service_' + item.id + '-' + check.id)"
                                        v-bind:data-vv-as="' '"
                                        v-bind:disabled="blocked"
                                        v-bind:dirty.sync="dirtyObj[('service-' + item.id + '-' + check.id)]"
                                        v-on:change="changeService"
                                    )

                        div(v-if="item.type == 'select'")
                            z-select(
                                v-bind:label="item.name"
                                v-model="item.value"
                                v-bind:name="('freight_service_' + item.id)"
                                v-bind:id="('freight_service_' + item.id)"
                                v-bind:error="errors.first(('freight_service_' + item.id))"
                                v-bind:data-vv-name="('freight_service_' + item.id)"
                                v-bind:data-vv-as="' '"
                                v-bind:disabled="blocked"
                                inline
                                v-bind:dirty.sync="dirtyObj[('service-' + item.id)]"
                            )
                                option(v-bind:key="`freight_service_${item.id}-default`" value="") Укажите значение
                                option(
                                    v-for="check in item.values" v-bind:key="check.id" v-bind:value="check.id"
                                ) {{ check.id + ' - ' + check.name }}
                          
</template>
<script>
    import ZFreightExtraService from '@/components/ZFreightExtraService';
    import Properties from '@/components/Properties'
    import ToggleCard   from '@/components/ToggleCard'
    import ZInput from '@/components/ZInput';
    import ZSelect from '@/components/ZSelect';
    import ZCheck from '@/components/ZCheck';
    export default {
        name: 'freight',
        props: {
            value: {
                type: Object,
                default: () => {
                    return {
                        id: null,
                        number: null,
                        description: null,
                        storekeeper_comment: null,
                        size: 0,
                        size_units: 'м',
                        status_id: null,
                        deal_id: null,
                        tracking_id: null,
                        traking_number: null,
                        weight: null,
                        height: null,
                        length: null,
                        width: null,
                        oversize: null,
                        oversize_size: null,
                        oversize_weight: null,
                        seats_number: null,
                        doom: 0,
                        factory_package: null,
                        price: 0,
                        full_price: '',
                        sort: 100,
                        from_signature: null,
                        from_stock_signature: null,
                        to_signature: null,
                        custom_price: null,
                        acceptedtracking: null,
                        issuedtracking: null,
                        status: null,
                        deal: {},
                        services: [],
                        from_luw_hours:   0,
                        from_luw_workers: 0,
                        to_luw_hours:   0,
                        to_luw_workers: 0,
                        airport_service: 0,
                        extraservices: {},
                        currenttracking: null,
                        route_lists: []
                    }
                }
            },
            deal: {
                type: Object,
                default: () => {
                    return {
                        id: null,
                        delivery_method_from: 1,
                        delivery_method_to: 1,
                    }
                }
            },
            block: {
                type: Boolean,
                default: false
            },
            dirty: {
                type: Boolean,
                default: false
            },
            payers: {
                type: Array,
                default: []
            },
            fromLuw: {
                type: Object,
                default: () => ({
                    id: null,
                    min_time: 0,
                    price: 0,
                    city_id: null,
                    zone_id: null,
                    type: 0                    
                })
            },
            toLuw: {
                type: Object,
                default: () => ({
                    id: null,
                    min_time: 0,
                    price: 0,
                    city_id: null,
                    zone_id: null,
                    type: 0                    
                })
            },
            isDealDirty: {
                type: Boolean,
                default: false
            },

            isUserHasHighPermission: {
                type: Boolean,
                default: false
            },
            isUserAgent: {
                type: Boolean,
                default: false
            },
            isUserAdmin: {
                type: Boolean,
                default: false
            },
            isUserManager: {
                type: Boolean,
                default: false
            },

            isDealCanceled: {
                type: Boolean,
                default: false
            },
            isIssueToTransfer: {
                type: Boolean,
                default: false
            },
            isEnteredToStock: {
                type: Boolean,
                default: false
            },
            isIssusedToClient: {
                type: Boolean,
                default: false
            },
        },
        components: {
            Properties, ToggleCard,
            ZInput, ZSelect, ZCheck, ZFreightExtraService
        },
        data() {
            return {
                parent: null,
                ttn: true,
                fullOversizeMessage: null,
                doomWeight: null,
                doomSize: null,
                OversizeType: [],
                freight: {
                    id: null,
                    number: null,
                    description: null,
                    storekeeper_comment: null,
                    size: 0,
                    size_units: 'м',
                    status_id: null,
                    deal_id: null,
                    tracking_id: null,
                    traking_number: null,
                    weight: 0,
                    height: 0,
                    length: 0,
                    oversize_width: 0,
                    oversize_height: 0,
                    oversize_length: 0,
                    width: 0,
                    oversize: 0,
                    full_oversize: 0,
                    oversize_size: 0,
                    oversize_weight: 0,
                    seats_number: 0,
                    doom: 0,
                    doom_make: 0,
                    factory_package: null,
                    price: 0,
                    full_price: '',
                    sort: 100,
                    from_signature: null,
                    from_stock_signature: null,
                    to_signature: null,
                    custom_price: null,
                    acceptedtracking: null,
                    issuedtracking: null,
                    status: null,
                    from_luw_hours:   0,
                    from_luw_workers: 0,
                    to_luw_hours:   0,
                    to_luw_workers: 0,
                    from_manipulator_hours: 0,
                    to_manipulator_hours: 0,
                    airport_service: 0,
                    deal: {},
                    services: [],
                    extraservices: {},
                    currenttracking: null,
                    route_lists: []
                },
                defaultFreight: {
                    id: null,
                    number: null,
                    description: null,
                    storekeeper_comment: null,
                    size: 0,
                    size_units: 'м',
                    status_id: null,
                    deal_id: null,
                    tracking_id: null,
                    traking_number: null,
                    weight: 0,
                    oversize: 0,
                    width: 0,
                    height: 0,
                    length: 0,
                    oversize_width: 0,
                    oversize_height: 0,
                    oversize_length: 0,
                    full_oversize: 0,
                    oversize_size: 0,
                    oversize_weight: 0,
                    seats_number: 0,
                    doom: 0,
                    doom_make: 0,
                    factory_package: null,
                    price: 0,
                    full_price: '',
                    sort: 100,
                    from_signature: null,
                    from_stock_signature: null,
                    to_signature: null,
                    custom_price: null,
                    acceptedtracking: null,
                    issuedtracking: null,
                    status: null,
                    from_luw_hours:   0,
                    from_luw_workers: 0,
                    to_luw_hours:   0,
                    to_luw_workers: 0,
                    from_manipulator_hours: 0,
                    to_manipulator_hours: 0,
                    airport_service: 0,
                    deal: {},
                    services: [],
                    extraservices: {},
                    currenttracking: null,
                    route_lists: []
                },
                dbFreight: {},
                dbServices: [],
                services: {},
                servicesSections: [
                    {
                        title: 'Дополнительные услуги',
                        key: 'services'
                    },
                    {
                        title: 'Тара и упаковка',
                        key: 'package'
                    }
                ],
                dirtyObj: {
                    seats: false,
                    weight: false,
                    size: false,

                    oversize: false,

                    oversizeWeight: false,
                    oversizeSize: false,
                    
                    height: false,
                    length: false,
                    width: false,

                    oversizeHeight: false,
                    oversizeLength: false,
                    oversizeWidth: false,

                    sum: false,
                    doom: false,
                    doom_make: null,
                    description: false,
                    services: false,

                    fromLuwHours:   false,
                    fromLuwWorkers: false,
                    toLuwHours:   false,
                    toLuwWorkers: false,

                    fromManipulatorHours: false,
                    toManipulatorHours: false,

                    airportService: false
                },
                extraservicesDefault: {},
                manupulatorPriceDefault: {
                    id: null,
                    is_min: 0,
                    min_time: 0,
                    price: 0,
                    type: 1,
                    value_max: 0,
                    value_min: 0,
                },
                manupulatorPrice: {
                    id: null,
                    is_min: 0,
                    min_time: 0,
                    price: 0,
                    type: 1,
                    value_max: 0,
                    value_min: 0,
                },
            }
        },
        computed: {
            blocked() {
                // Если пользователь администратор, то он всегда может редактировать параметры груза
                if (this.$props.isUserAdmin) return false;

                // Остальные условия сработают только для представителя и менеджера

                // Если заявка выдана клиенту и пользователь не админ, тогда он не может редактировать параметры груза
                if (this.$props.isIssusedToClient && !this.$props.isUserAdmin) return true;

                // Если заявка была выдана на перемещение или принята с перемещения, то менять параметры груза может только админ или менеджер
                if ((this.$props.isIssueToTransfer || this.$props.isEnteredToStock) && !this.$props.isUserAdmin && !this.isUserManager) return true;
            },
            progressMainFreight() {
                return this.progressObj['load-main-freight-card'];
            },
            progressObj() {
                return this.$store.state.progressObj;
            },
            computedVolume() {
                if (
                    !this.freight.height || !this.freight.length || !this.freight.width ||
                    this.freight.height <=0 || this.freight.length <= 0 || this.freight.width <= 0
                ) return;
                return parseFloat(this.freight.height * this.freight.length * this.freight.width).toFixed(3);
            },
            computedSum() {
                if (
                    !this.freight.height || !this.freight.length || !this.freight.width ||
                    this.freight.height <= 0 || this.freight.length <= 0 || this.freight.width <= 0
                ) return 0;
                return parseFloat(parseFloat(this.freight.height) + parseFloat(this.freight.length) + parseFloat(this.freight.width)).toFixed(3);
            },
            hasDoom() {
                return (!this.freight || !this.freight.doom || parseInt(this.freight.doom) == 0) ? false : true;
            },
            readyToCheckOversize() {
                return (this.freight.size > 0 && this.freight.weight > 0) ? true : false;
            },
            oversizeCheckProps() {
                return [
                    parseInt(this.freight.oversize) || 0,
                    parseInt(this.freight.doom) || 0,
                    parseFloat(this.freight.size) || 0,
                    parseFloat(this.freight.weight) || 0,
                    parseFloat(this.freight.height) || 0,
                    parseFloat(this.freight['length']) || 0,
                    parseFloat(this.freight.width) || 0,
                    parseFloat(this.freight.oversize_weight) || 0,
                    parseFloat(this.freight.oversize_size) || 0,
                    parseFloat(this.freight.oversize_height) || 0,
                    parseFloat(this.freight.oversize_length) || 0,
                    parseFloat(this.freight.oversize_width) || 0,
                    parseFloat(this.computedSum).toFixed(3)
                ].join('-');
            },
            readyToCheckManipulator() {
                return (
                    this.$props.deal.delivery_method_from && this.$props.deal.delivery_method_to &&
                    this.freight.size > 0 && this.freight.weight > 0
                ) ? true : false;
            },
            manipulatorCheckProps() {
                return [
                    this.freight.size,
                    this.freight.weight,
                    this.$props.deal.delivery_method_from,
                    this.$props.deal.delivery_method_to
                ].join('-');
            },            
            doomLabel() {
                return 'Обрешётка' + ((this.doomWeight && this.doomSize) ? (' (Вес: ' + this.doomWeight + 'кг, Объём: ' + this.doomSize + 'м<sup>3</sup>)') : '');
            },
            isDirty() {
                return !!Object.values(this.dirtyObj).find(item => item);
            },
            shwowLuwFrom() {
                return this.$props.deal.delivery_method_from && parseInt(this.$props.deal.delivery_method_from) === 2
            },
            shwowLuwTo() {
                return this.$props.deal.delivery_method_to && parseInt(this.$props.deal.delivery_method_to) === 2
            },
            shwowManipulatorFrom() {
                return this.$props.deal.delivery_method_from && parseInt(this.$props.deal.delivery_method_from) === 2
            },
            shwowManipulatorTo() {
                return this.$props.deal.delivery_method_to && parseInt(this.$props.deal.delivery_method_to) === 2
            },            
        },
        watch: {
            'isDirty'(val) {
                if (val) this.emitDirty();
            },
            '$props.value': {
                deep: true,
                handler(value) {
                    if (JSON.stringify(value) != JSON.stringify(this.freight)) this.init();
                }
            },
            'freight': {
                deep: true,
                handler(freight) {
                    this.$emit('change', freight);
                    this.$emit('input', freight);
                }
            },
            'services': {
                deep: true,
                handler(services) {
                    let service = [];
                    Object.values(services).map(item => service = service.concat(item));
                    this.freight.service = Object.assign([], service);
                }
            },
            'oversizeCheckProps'(value) {
                let oldValue = value;
                setTimeout(() => {
                    if (this.oversizeCheckProps == oldValue && this.readyToCheckOversize) this.checkOversize();
                }, 1000);
            },
            'manipulatorCheckProps'(value) {
                let oldValue = value;
                setTimeout(() => {
                    if (this.manipulatorCheckProps == oldValue && this.readyToCheckManipulator) this.suggestManipulatorPrice();
                }, 1000);
            },
            'freight.oversize'(value) {
                this.freight.oversize = parseInt(value);              
            },
            'freight.doom'() {
                this.handleDoom()
            },
            'computedVolume'(value) {
                if (value) this.freight.size = value;
                else this.freight.size = 0;
            },
            '$props.deal.delivery_method_from'(val) { // Если способ забора не "С адреса", то выключаем манипулятор
                if (this.$props.isDealDirty && parseInt(val) !== 2) this.freight.from_manipulator_hours = 0;
            },
            '$props.deal.delivery_method_to'(val) { // Если способ доставки не "До адреса", то выключаем манипулятор
                if (this.$props.isDealDirty && parseInt(val) !== 2) this.freight.to_manipulator_hours = 0;
            }
        },
        methods: {
            changeService() {
                this.$forceUpdate();
            },
            emitDirty() {
                this.$emit('update:dirty', this.isDirty);
            },
            init() {
                this.validateClear();
                if (this.$props.value && this.$props.value.id && this.$props.value.id != 'new') {
                    if (this.$props.value && JSON.stringify(this.$props.value) != JSON.stringify(this.freight)) {
                        //this.$store.commit('showProgressBar', 'load-deal-card');
                        this.freight = Object.assign({}, this.$props.value);
                        //this.checkExtraservices();
                        //this.getFreight().then(() => {
                            this.suggestManipulatorPrice();
                            this.getServices();
                            this.getPayersServices();

                            //Если пользователь клонирует заявку
                            if (this.$route.query && this.$route.query.clone_id) {
                                this.freight.id = null;
                                this.freight.price = 0;
                                this.freight.full_price = Object.assign({}, {});
                                this.freight.custom_price = 0;
                                this.freight.traking_number = null;
                                this.freight.status_id = null;
                                this.freight.status = Object.assign({}, {});
                                this.freight.acceptedtracking = Object.assign({}, {});
                                this.freight.currenttracking = Object.assign({}, {});
                                this.freight.issuedtracking = Object.assign({}, {});
                                this.freight.status = Object.assign({}, {});
                                this.freight.status_id = null;
                                this.freight.to_signature = null;
                                this.freight.from_signature = null;
                                this.freight.from_stock_signature = null;
                                this.freight.to_signature_date = null;
                                this.freight.from_signature_date = null;
                                this.freight.from_stock_signature_date = null;
                            }
                        //}).finally(() => this.$store.commit('hideProgressBar', 'load-deal-card'));
                    }
                } else {
                    //Если нет ID, то сбрасываем объект груза на дефолтный
                    if (!this.$props.value || !this.$props.value.id || this.$props.value.id == 'new')
                        this.freight = Object.assign({}, this.defaultFreight);

                    this.getServices();
                    this.getPayersServices();
                    this.suggestManipulatorPrice();
                }
            },
            checkExtraservices() {
                if (!this.freight.extraservices || !Object.values(this.freight.extraservices).length)
                    this.freight.extraservices = Object.assign({}, this.extraservicesDefault);
            },
            validateClear() {
                this.errors.clear();
                this.$validator.errors.clear();
                this.$validator.reset();
            },
            updateServicesValues() {
                //this.getFreight().then(() => {
                    if (this.dbServices && this.dbServices.length) this.prepareServices(this.dbServices);
                    else this.getServices();
                //});
            },
            getFreight() {
                if (!this.freight.id || this.freight.id == 'new') return new Promise((resolve, reject) => resolve());
                return this.$store.dispatch('deals/getFreightById', this.freight.id).then(r => {
                    if (r) {
                        r.doom = parseInt(r.doom);
                        r.factory_package = parseInt(r.factory_package);
                        r.oversize = (parseInt(r.oversize) === 1) ? 1 : 0;
                        this.dbFreight = Object.assign({}, r);
                    }
                });
            },
            getPayersServices() {
                return this.$store.dispatch('deals/getFreightPayersServices').then(services => this.preparePayerServices(services));
            },
            preparePayerServices(services) {
                if (!this.freight.extraservices) this.freight.extraservices = {};
                if (!services || !Object.values(services).length) return;
                Object.entries(services).forEach(([key, value]) => {
                    if (!this.freight.extraservices[key]) this.freight.extraservices[key] = Object.assign({}, value)
                })
            },
            getServices(section) {
                this.services = Object.assign({}, {});
                let params = {
                    order_by: 'sort',
                    filter: (section) ?
                        {model: [['section','=',section],'and',['active','=','1']], relation: []} :
                        {model: [['active','=','1']], relation: []}
                };
                return this.$store.dispatch('deals/getFreigtsServices', params).then(services => {
                    this.dbServices = Object.assign([], services);
                    this.prepareServices(services);
                });
            },
            prepareServices(services) {
                if (!services || !Array.isArray(services)) return;
                let result = {};
                services.map(service => {
                    if (service.type == 'checkbox') service.value = [];
                    else service.value = null;
                });
                
                if (this.freight && this.freight.services && this.freight.services.length) this.freight.services.map(serviceValue => {
                    services.map(service => {
                        if (parseInt(service.id) == parseInt(serviceValue.service.id)) {
                            if (service.type == 'checkbox') service.value.push(serviceValue.id);
                            else service.value = serviceValue.id;
                        }
                    });
                });

                services.map(service => {
                    if (!result[service.section]) result[service.section] = [];
                    result[service.section].push(service);
                });

                this.services = Object.assign({}, result);
            },
            getOversizeLabel(types) {
                let type = types.find(item => !!item);
                switch (type) {
                    case 'sum':    return 'сумме сторон';
                    case 'weight': return 'весу';
                    case 'size':   return 'объёму';
                    case 'volume': return 'объёму';
                    case 'height': return 'высоте';
                    case 'length': return 'длине';
                    case 'width':  return 'ширине';
                    default: return 'установке пользователя';
                }
            },
            checkOversize() {
                this.$store.commit('showProgressBar', 'load-main-freight-card');
                let freight = Object.assign({}, this.freight);
                this.doomWeight   = 0;
                this.doomSize     = 0;
                this.OversizeType = [];
                return this.$store.dispatch('deals/checkFreightOversize', {deal: this.$props.deal, freight: freight, freight_id: this.freight.id}).then(r => {
                    if (r && !!this.freight.doom) {
                        this.doomWeight = r.doom_weight;
                        this.doomSize   = r.doom_size;
                    }
                    
                    if (r && (!!this.freight.oversize || !!r.oversize)) {
                        if (r.oversize_type) this.OversizeType = Object.assign([], r.oversize_type);
                        this.fullOversizeMessage = (r.oversize_type) ? 'Груз является частичным негабаритом по <b>' + this.getOversizeLabel(r.oversize_type) + '</b>' : 'Груз является частичным негабаритом';
                        if (r.full_oversize) {
                            this.fullOversizeMessage = (r.oversize_type) ? 'Груз является полным негабаритом по <b>' + this.getOversizeLabel(r.oversize_type) + '</b>.' : 'Груз является полным негабаритом.';
                            if (!!this.freight.doom) this.fullOversizeMessage += ' Изменение параметров негабаритности заблокировано.';
                        }
                        this.freight.full_oversize = (r.full_oversize) ? 1 : 0;
                        // Если полный негабарит и включена обрешётка то устанавливаем значения негабаритности т.к. пользователь не может редактировать эти поля при включённой обрешётке
                        // Если обрешётка выключена, то поля не трогаем чтобы пользователь сам мог указать параметры нагабаритности (смотри задачу FLC-1408)
                        if (this.freight.full_oversize && this.freight.doom) {
                            this.$set(this.freight, 'oversize_weight', parseFloat(this.freight.weight));
                            this.$set(this.freight, 'oversize_size',   parseFloat(this.freight.size));
                            this.$set(this.freight, 'oversize_height', parseFloat(this.freight.height));
                            this.$set(this.freight, 'oversize_length', parseFloat(this.freight.length));
                            this.$set(this.freight, 'oversize_width',  parseFloat(this.freight.width));
                        }
                    } else {
                        this.$set(this.freight, 'full_oversize',   0);
                        this.$set(this.freight, 'oversize_weight', 0);
                        this.$set(this.freight, 'oversize_size',   0);
                        this.$set(this.freight, 'oversize_height', 0);
                        this.$set(this.freight, 'oversize_length', 0);
                        this.$set(this.freight, 'oversize_width',  0);
                        this.fullOversizeMessage = null;
                    }
                }).finally(() => this.$store.commit('hideProgressBar', 'load-main-freight-card'));
            },
            validate() {
                return new Promise(async resolve => {
                    let ValidPromises = [this.$validator.validateAll()];

                    Object.keys(this.extraservicesDefault)
                        .filter(key => !!this.$refs[('extraserivce-' + key)])
                        .map(key => {
                            key = ('extraserivce-' + key);
                            if (Array.isArray(this.$refs[key]))
                                this.$refs[key].map(ref => ValidPromises.push(ref.validate()));
                            else 
                                ValidPromises.push(this.$refs[key].validate());
                        });

                    const valid = await Promise.all(ValidPromises).then(valid => valid.every(item => item == true));
                    resolve(valid);
                })
            },
            handleDoom() {
                this.$nextTick(() => {  
                    this.freight.doom = parseInt(this.freight.doom);
                    if (parseInt(this.freight.doom) === 1 && this.dirtyObj.doom) this.freight.extraservices.doom_make.value.value = true;
                    if (parseInt(this.freight.doom) === 0 && this.dirtyObj.doom) this.freight.extraservices.doom_make.value.value = false;
                })
            },
            suggestManipulatorPrice() {
                if (!this.readyToCheckManipulator) return;
                this.manupulatorPrice = Object.assign({}, this.manupulatorPriceDefault);
                return this.$store.dispatch('cost/suggestManipulatorPrice', {
                    wight:  this.freight.weight,
                    volume: this.freight.size,
                }).then(r => {
                    if (!r || !r.id) return;
                    this.manupulatorPrice = Object.assign({}, r);
                });
            }
        },
        created() {
            this.init();
        },
    }
</script>
<style lang="sass">
    #z-deal-freight.deal-freight-card
        padding: 0 8px 8px 8px !important
        .full_oversize
            font-size: 12px
            line-height: 14px
            color: red
        .oversized
            min-height: 40px
            padding-top: 10px
            .md-layout-item 
                flex: 0 0 auto
            .z-input
                margin: 0
            .z-check
                height: 26px
                display: flex
                align-items: center
</style>


// WEBPACK FOOTER //
// Freight.vue?10542e98